import React from 'react'
import { IconAiUser } from '../../../icons/IconAiUser'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styles from './AiMessage.module.scss'
import clsx from 'clsx'

interface MessageProps {
  children?: string
  type: 'input' | 'output'
  time?: string
}

export const AiMessage: React.FC<MessageProps> = ({ children, type }) => {
  const isInput = type === 'input'

  return (
    <div className='flex gap-[8px] items-end'>
      <div className={'pb-[8px]'}>
        {!isInput && (
          <div className={'w-[25px] h-[25px] rounded-full p-[5px] pl-[6px] bg-[#E8EFFA]'}>
            <div className={'w-[22px]'}>
              <IconAiUser color={'#00326D'} />
            </div>
          </div>
        )}
      </div>
      <div
        className={`w-fit p-[8px] text-focus-500 rounded-[8px] min-w-[50%] max-w-[95%] ${
          isInput ? 'bg-[#E8EFFA] rounded-br-[0px] ml-auto' : 'rounded-bl-[0px]'
        }`}
      >
        <div className={clsx(styles.message)}>
          <Markdown remarkPlugins={[[remarkGfm, { singleTilde: false }]]}>{children}</Markdown>
        </div>
      </div>
    </div>
  )
}
